import { render, staticRenderFns } from "./ProductStatusBadge.vue?vue&type=template&id=181202e0&scoped=true"
import script from "./ProductStatusBadge.vue?vue&type=script&lang=ts"
export * from "./ProductStatusBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181202e0",
  null
  
)

export default component.exports